import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel, TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { REMOVE_LEASING_INTEREST } from '../mutations';
import { useMutation } from 'hooks/apollo';
import { leasingInterestModalVar } from 'features/leasingInterests/variables';
import { ADMIN_LEASING_INTERESTS_WRITE } from 'constants/rightsCodes';
import useConfirmDialog from 'features/common/components/confirm/useConfirmDialog';
import { usePermission } from 'providers/RightsHooks';
import FlexBox from 'components/common/FlexBox';
import { IconButton } from '@totalsoft/rocket-ui';

const LeasingInterestComponent = ({ data }) => {
  const { t } = useTranslation();
  const confirm = useConfirmDialog();
  const canWrite = usePermission(ADMIN_LEASING_INTERESTS_WRITE);

  const [removeLeasingInterest] = useMutation(REMOVE_LEASING_INTEREST);

  const handleDelete = useCallback(() => {
    confirm(
      () => {
        removeLeasingInterest({ variables: { interestTypeId: data.interestTypeId } });
      },
      {
        title: t('LeasingInterestType.DeleteLeasingInterest'),
        content: t('LeasingInterestType.AreYouSureDelete')
      }
    );
  }, [data.interestTypeId, removeLeasingInterest, t, confirm]);

  return (
    <TableRow hover key={data.interestTypeId}>
      <TableCell>{`${data.interestTypeName || ''}`}</TableCell>
      <TableCell>{`${data.interestTypeCode || ''}`}</TableCell>
      <TableCell>{`${data.currencyCode || ''}`}</TableCell>
      <TableCell>{`${data.periodicity || ''}`}</TableCell>
      <TableCell>
        <FormControlLabel
          control={<Checkbox checked={data.isFixed || false} size='small' sx={{ padding: '0' }} />}
          disabled={true}
          color='primary'
        />
      </TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton
            disabled={!canWrite}
            color='primary'
            size='small'
            variant='text'
            type='edit'
            tooltip={t('Edit')}
            onClick={() =>
              leasingInterestModalVar({
                open: true,
                item: {
                  interestTypeId: data.interestTypeId,
                  interestTypeName: data.interestTypeName,
                  interestTypeCode: data.interestTypeCode,
                  currencyId: data.currencyId,
                  currencyCode: data.currencyCode,
                  periodicity: data.periodicity,
                  isFixed: data.isFixed
                }
              })
            }
          />
          <IconButton
            disabled={!canWrite}
            size='small'
            color='primary'
            variant='text'
            type='delete'
            tooltip={t('Delete')}
            onClick={handleDelete}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

LeasingInterestComponent.propTypes = {
  data: PropTypes.object.isRequired
};

export default LeasingInterestComponent;
